import { memo } from 'react';
import Map from 'react-map-gl';

// @mui
// components
import Image from 'src/components/image';
import { MapMarker, MapControl } from 'src/components/map';
import { IEvent } from 'src/types/events';

import { getDefaultPicture } from '../../utils/picture';
import { StyledMapContainer, THEMES, baseSettings } from '../map-view/map-view';

export interface Props {
  event: IEvent;
  onMapClick: Function;
}

function EventMapMarkerPreview({ event, onMapClick }: Props) {
  return (
    <StyledMapContainer sx={{ height: '28vh', width: { sm: '100%', md: '80%' }, borderRadius: 2 }}>
      <Map
        {...baseSettings}
        initialViewState={{
          latitude: event.venue.latitude,
          longitude: event.venue.longitude,
          zoom: 15,
          bearing: 0,
          pitch: 0,
        }}
        mapStyle={THEMES.dark}
        doubleClickZoom={false}
        scrollZoom={false}
        touchZoomRotate={false}
        dragPan={false}
        dragRotate={false}
        keyboard={false}
        onClick={() => onMapClick()}
      >
        <MapControl
          settingQuery={() => {}}
          hideNavigationControl
          hideGallery
          hideGeolocateControl
          hideScaleControl
        />

        <MapMarker
          key={event.id}
          latitude={event.venue.latitude}
          longitude={event.venue.longitude}
          children={
            <Image
              src={(event?.cover ?? getDefaultPicture(event.pictures))?.url}
              sx={{
                width: 45,
                height: 45,
                borderRadius: '50%',
              }}
            />
          }
        />
      </Map>
    </StyledMapContainer>
  );
}

export default memo(EventMapMarkerPreview);
